<template>
  <layout :title="$route.name" :options="[]">
    <v-container><v-card class="pa-5 mx-auto" max-width="560">
      <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
      <template v-if="!operation">
        <v-text-field v-model="amount" label="Valor" prefix="R$" inputmode="decimal" />
        <v-btn block color="primary" :loading="loading" @click="create">Gerar Pix</v-btn>
      </template>
      <template v-else>
        <div class="text-center" v-if="operation.pix && pixCode"><qrcode-vue :value="pixCode" :size="220" class="my-4" /></div>
        <v-textarea v-if="pixCode" :value="pixCode" label="Pix copia e cola" readonly rows="3" />
        <v-btn v-if="pixCode" block outlined color="primary" @click="copy">Copiar código</v-btn>
        <v-alert class="mt-4" :type="operation.status === 'COMPLETED' ? 'success' : 'info'">{{ statusText }}</v-alert>
        <v-btn v-if="operation.status === 'COMPLETED'" block text to="/conta-scn">Voltar à Conta SCN</v-btn>
      </template>
    </v-card></v-container>
  </layout>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import service from "./service";
export default {
  components: { QrcodeVue },
  data: () => ({ amount: "", operation: null, loading: false, error: null, timer: null, key: null }),
  computed: {
    pixCode() { return this.operation && this.operation.pix && (this.operation.pix.copyPaste || this.operation.pix.qrcode); },
    statusText() { return this.operation.status === "COMPLETED" ? "Saldo adicionado com sucesso." : "Aguardando confirmação do pagamento."; }
  },
  beforeDestroy() { if (this.timer) clearTimeout(this.timer); },
  methods: {
    cents() { const value = Number(`${this.amount}`.replace(/\./g, "").replace(",", ".")); return Math.round(value * 100); },
    newKey() { return `deposit_${Date.now()}_${Math.random().toString(36).slice(2)}`; },
    async create() { this.loading = true; this.error = null; this.key = this.key || this.newKey(); try { this.operation = (await service.createDeposit({ amount: this.cents() }, this.key)).data; this.poll(); } catch (e) { this.error = (e.response && e.response.data && e.response.data.message) || "Não foi possível gerar o Pix"; } finally { this.loading = false; } },
    async poll() { if (!this.operation || ["COMPLETED", "FAILED", "REFUNDED", "CHARGEDBACK"].includes(this.operation.status)) return; this.timer = setTimeout(async () => { try { this.operation = (await service.getDeposit(this.operation.id)).data; } finally { this.poll(); } }, 4000); },
    async copy() { if (navigator.clipboard) await navigator.clipboard.writeText(this.pixCode); }
  }
};
</script>
